import React from 'react';

import PageTemplate from '../components/templates/PageTemplate';
import MembersView from '../components/organisms/MembersView';

const MembersContainer = () => {
  return (
    <PageTemplate>
      {/* ph-no-capture: exclude member PII in this view from PostHog autocapture */}
      <div className="ph-no-capture">
        <MembersView />
      </div>
    </PageTemplate>
  );
};

export default MembersContainer;
